import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step8 } from '../../../../shared/models/component-messages/blocCommun/divers/step8';
import { TypeMotsClef } from '../../../common/models/TypeMotsClef';
@Component({
  selector: 'app-type-mots-clef',
  templateUrl: './type-mots-clef.component.html'
})
export class TypeMotsClefComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeMotsClef';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() motsClef: TypeMotsClef;

  public step8 = new Step8();

  constructor() {}

  public ngOnInit() {}

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

}

